module.exports = __webpack_public_path__ + "img/wa-icon.62c9b836.png";